<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yidfTT/tc-custom/9780061972706.jpg?1725288189179" alt="This image is the cover for the book Almost Perfect Moment"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Almost Perfect Moment
      </h1>
      <p class="bookDescription body article font2">
        <p>In Brooklyn, in the Age of Disco, Valentine Kessler -- a sweet Jewish girl who bears a remarkable resemblance to the Virgin Mary of Lourdes -- has an unerring gift for shattering the dreams and hopes of those who love her. Miriam, her long-suffering mother, betrayed and anguished by the husband she adores, seeks solace in daily games of mah-jongg with The Girls, a cross between a Greek Chorus and Brooklyn's rendition of the Three Wise Men, who dispense advice, predictions, and care in the form of poppy-seed cake and apple strudels. When her greatest fear for Valentine is realized, Miriam takes comfort in the thought that it couldn't get any worse. And then it does.</p><p>Sagacious, sorrowful, and hilarious, <i>An Almost Perfect Moment</i> is a novel about mothers and daughters, star-crossed lovers, doctrines of the divine, and a colorful Jewish community that once defined Brooklyn.</p><p>This P.S. edition features an extra 16 pages of insights into the book, including author interviews, recommended reading, and more.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Binnie Kirshenbaum
      </h2>
      
      <p class="authorDescription body article"><P>Binnie Kirshenbaum is the author of <I>An Almost Perfect Moment, On Mermaid Avenue, A Disturbance in One Place, Pure Poetry, Hester Among the Ruins,</I> and <I>History on a Personal Note.</I> She is a professor at Columbia University's School of the Arts, where she is chair of the Graduate Writing Program.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1f149703